// api/services/agencies.ts
import { handleRequest } from '@/api';
import type { Agency } from '@/types';

interface FetchOpts {
    signal?: AbortSignal;
}

interface AgencyOperationResponse {
    message: string;
    agency_id: number | null;
}

interface AgencyPayload {
    agency_name: string;
    domain?: string;
    admin_email?: string;
    country_code?: string;
    country_list?: string[];
}

interface AgencyUpdatePayload extends AgencyPayload {
    id: number;
}

export const createAgency = (payload: AgencyPayload): Promise<AgencyOperationResponse> =>
    handleRequest<AgencyOperationResponse>('post', `/agencies/`, payload, 'Agency saved successfully!');

export const updateAgency = (payload: AgencyUpdatePayload): Promise<AgencyOperationResponse> =>
    handleRequest<AgencyOperationResponse>('put', `/agencies/${payload.id}`, payload, 'Agency updated successfully');

export const deleteAgency = (agencyId: number): Promise<void> =>
    handleRequest<void>('delete', `/agencies/${agencyId}`, {}, 'Agency deleted successfully!');

export const associateAgency = (selectedAgency: { id: number }): Promise<void> =>
    handleRequest<void>('post', `/agencies/${selectedAgency.id}/associate`, {}, 'Agency associated successfully!');

export const getAssociatedAgencies = (opts: FetchOpts = {}): Promise<Agency[]> =>
    handleRequest<Agency[]>('get', `/agencies/?associated=true`, opts);

export const getUnassociatedAgencies = (opts: FetchOpts = {}): Promise<Agency[]> =>
    handleRequest<Agency[]>('get', `/agencies/?associated=false`, opts);

/** All agencies in the caller's jurisdiction — for AoR dropdown */
export const getTerritorialAgencies = (opts: FetchOpts = {}): Promise<Agency[]> =>
    handleRequest<Agency[]>('get', `/agencies/?associated=territorial`, opts);

/** Superuser only — returns all agencies with no association filter */
export const getAllAgencies = (): Promise<Agency[]> => handleRequest<Agency[]>('get', `/agencies/`);
